<div data-testid="stock-alert-page" class="p-6 stock-alert-container flex-table-page">
  <!-- Header -->
  <div class="mb-6 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "stock_alert.title" | translate }}
    </h2>
  </div>

  <!-- Search Form -->
  <app-search-form
    data-testid="stock-alert-search-form"
    [searchFormat]="searchConfig()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-button
        [testId]="'stock-alert-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="stock-alert-table"
      #advancedTable
      [dataSource]="alerts()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      scrollHeight="flex"
      [showInternalColumnConfigButton]="false"
      (pageChange)="onPageChange($event)"
    >
    <!-- Custom Template for Type and Severity -->
    <ng-template
      #customTemplate
      let-value
      let-record="rowData"
      let-column="column"
    >
      @if (column.prop === "type") {
        <span>{{ formatType(value) }}</span>
      } @else if (column.prop === "severity" && value) {
        @let colors = getSeverityColors(record.type, value);
        <span
          class="severity-badge"
          [style.background-color]="colors.bg"
          [style.color]="colors.text"
        >
          {{ formatSeverity(value) }}
        </span>
      } @else {
        {{ value }}
      }
    </ng-template>

    <!-- Status Template -->
    <ng-template #statusTemplate let-status>
      <div class="flex items-center justify-center gap-1 w-full">
        <p-tag
          data-testid="stock-alert-status-tag"
          [value]="formatStatus(status)"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
          size="small"
        />
      </div>
    </ng-template>

    <!-- Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      @if (canApprove()) {
        <div class="flex gap-2 justify-center">
          @if (canResolve(rowData)) {
            <app-button
              [testId]="'stock-alert-action-resolve-' + rowData.id"
              class="action-resolve"
              [label]="'stock_alert.actions.resolve' | translate"
              type="action"
              [disabled]="loading()"
              (emitOnClick)="onResolve(rowData)"
            ></app-button>
          }
          @if (canSuppress(rowData)) {
            <app-button
              [testId]="'stock-alert-action-suppress-' + rowData.id"
              class="action-suppress"
              [label]="'stock_alert.actions.suppress' | translate"
              type="action"
              [disabled]="loading()"
              (emitOnClick)="onSuppress(rowData)"
            ></app-button>
          }
        </div>
      }
    </ng-template>
    </advanced-data-table>
  </div>

  <!-- Toast Messages -->
  <p-toast data-testid="stock-alert-toast"></p-toast>

  <!-- Alert Reason Dialog -->
  <app-alert-reason-dialog
    data-testid="stock-alert-reason-dialog"
    [visible]="showReasonDialog()"
    [data]="reasonDialogData()"
    (visibleChange)="showReasonDialog.set($event)"
    (result)="onReasonDialogResult($event)"
  ></app-alert-reason-dialog>
</div>
